import { RespondInterface, RespondModel } from './respond-interface';
import { CustomValidators } from 'app/pages/A2-utils/custom-validators';
import { Validators, AbstractControl, FormGroup } from '@angular/forms';
import { _getArray, _evalOperators, _evalOnlyBooleans } from './utils/helpers';
import { isProperty } from 'app/pages/A2-utils/custom-validators/utils/helpers';
import { isDynamicValue, resolveDynamicValue, toComparableDate } from './dynamic-values';

declare const $: any;

export class Tr2ValidationBuilder {

  protected static validated: any = [];
  protected static operations: any = [];
  protected static respond = new RespondModel();
  protected static onError: boolean;
  protected static reactiveForm: FormGroup;
  protected static onSubscribe = [];
  protected static _onSubscribe: any = undefined;
  protected static rules: any;
  protected static debounceTime = 1500;
  protected static defaultHidden: string[] = [];
  protected static onCascade = false;

  private static toggleHide(formControlName: string, value?: boolean) {
    try {
      $(`[formControlName="${formControlName}"]`)
        .parent()
        [value ? 'addClass' : 'removeClass']('hiddenValidator');
      $(`[formControlNameContainer="${formControlName}"]`)
        [value ? 'addClass' : 'removeClass']('hiddenValidator');
    } catch (error) {
    }
  }

  private static toggleReadOnly(formControlName: string, value?: boolean) {
    try {
      $(`[formControlName="${formControlName}"]`)
        [value ? 'attr' : 'removeAttr']('readonly', true);
    } catch (error) {
    }
  }

  /**
   * Aplicar
   * @param obj
   */
  private static setValidators (obj, emitEventUpdate = false) {
    try {

      if (this._onSubscribe !== undefined) {
        this._onSubscribe.unsubscribe();
        this._onSubscribe = undefined;
      }

      let hasWrittenValue = false;

      Object.keys(obj).forEach((key) => {
        if (this.reactiveForm.get(obj[key].formControlName)) {
          this.reactiveForm.get(obj[key].formControlName).clearValidators();
          this.reactiveForm.get(obj[key].formControlName).setValidators(obj[key].validators);
          this.reactiveForm.get(obj[key].formControlName).updateValueAndValidity({emitEvent : emitEventUpdate});

          obj[key].properties.forEach((property) => {
            const propertyName = property.split('(')[0];
            if (property === 'hide') {
              this.reactiveForm.controls[obj[key].formControlName]['hide'] = true;
              this.toggleHide(obj[key].formControlName, true);
            } else if (property === 'show') {
              this.reactiveForm.controls[obj[key].formControlName]['hide'] = false;
              this.toggleHide(obj[key].formControlName, false);
            } else if (property === 'readOnly') {
              this.reactiveForm.controls[obj[key].formControlName]['readOnly'] = true;
              this.toggleReadOnly(obj[key].formControlName, true);
            } else if (propertyName === 'setValue') {
              const rawParam = property.substring(propertyName.length + 1, property.length - 1);
              const nextValue = rawParam && !isNaN(rawParam) ? Number(rawParam) : rawParam;
              const target = this.reactiveForm.get(obj[key].formControlName);
              if (target.value !== nextValue) {
                target.setValue(nextValue, { emitEvent: false });
                hasWrittenValue = true;
              }
              this.reactiveForm.controls[obj[key].formControlName]['forced'] = true;
            } else {
              this.reactiveForm.get(obj[key].formControlName)[property]();
            }
          });
        }
      });

      if (hasWrittenValue && !this.onCascade) {
        this.onCascade = true;
        try {
          this.buildRules(this.rules, emitEventUpdate);
        } finally {
          this.onCascade = false;
        }
        return this;
      }

      this._onSubscribe = this.reactiveForm
      .valueChanges
      .debounceTime(this.debounceTime)
      .subscribe((value) => {
        this.buildRules(this.rules, false);
      });
    } catch (error) {
      this.error(error);
    }
    return this;
  }

  /**
   * @description Retornar error
   */
  private static error (error: TypeError | string): RespondInterface {
    this.onError = true;
    this.respond.success = false;
    if (typeof error === 'string') {
      this.respond.message = error;
    } else {
      this.respond.errors.push(error);
    }
    return this.respond;
  }

  private static buildRules(rules, emitEventUpdate?: boolean) {
      const _result = {};
      if (!rules) { return; }
      rules.forEach(rule => {
        if (rule.status) {
          const build = Tr2ValidationBuilder;
          build.reset();
          const acomulator_validtadors = [];
          rule.validators.forEach(valid => {
            let v = valid.code;
            if (valid.input) {
              v = v + `(${valid.input_value})`;
            }
            acomulator_validtadors.push(v);
          });
          build.applyRules(acomulator_validtadors);
          if (!this.reactiveForm) { return; }
          rule.conditions.forEach(param => {
            const control = this.reactiveForm.get(param.field);
            if (!control) { return; }
            const conditionValue = param.value.split('@:@')[0];
            if (isDynamicValue(conditionValue)) {
              build[param.condition](
                toComparableDate(control.value),
                param.operator,
                resolveDynamicValue(conditionValue)
              );
              return;
            }
            build[param.condition](
              control.value,
              param.operator,
              !isNaN(conditionValue) ? Number(conditionValue) : conditionValue
            );
          });
          const setValidators = build.get();
          if (!_result[rule.field]) {
            _result[rule.field] = {
              validators: setValidators.validations,
              properties: setValidators.properties,
              formControlName: rule.field
            };
          }
          setValidators.validations.forEach(element => {
            if (_result[rule.field].validators.indexOf(element) === -1) {
              _result[rule.field].validators.push(element);
            }
          });

          setValidators.properties.forEach(element => {
            if (_result[rule.field].properties.indexOf(element) === -1) {
              _result[rule.field].properties.push(element);
            }
          });
        }
      });
      this.setValidators(_result);


    return this;
  }

  /**
   * @description Generar Validators
   * @param rules Array
   */
  static getValidator(rules) {
    try {
      const _rules = [];
      const _properties = [];
      rules.forEach(element => {
        const split = element.split('(');
        if (split.length > 1) {
          const params = element.substr(split[0].length + 1 , (element.length - 1) - (split[0].length + 1));
          if (isProperty(split[0])) {
            _properties.push(`${isProperty(split[0])}(${params})`);
          } else if (split[0] === 'pattern' || split[0].search(CustomValidators._name) !== -1) {
            if (split[0] === 'pattern') {
              const regex = new RegExp(params);
              _rules.push(Validators[split[0]](regex));
            }
            if (split[0].search(CustomValidators._name) !== -1) {
              _rules.push(
                CustomValidators[split[0].split(CustomValidators._nameSplit)[1]](params)
              );
            }
          } else {
            _rules.push(Validators[split[0]](params));
          }
        } else {
          const custom = element.split(CustomValidators._nameSplit);
          if (custom.length === 2 ) {
            _rules.push(CustomValidators[custom[1]]);
          } else {
            if (isProperty(element)) {
              _properties.push(isProperty(element));
            } else {
              _rules.push(Validators[element]);
            }
          }
        }
      });

      return {
        rules: _rules,
        properties: _properties
      };
    } catch (error) {
      this.error(error);
    }

    return undefined;
  }

  /**
   * @description Reglas a aplicar
   * @param rules
   */
  public static applyRules (...rules) {
    try {
      this.validated = _getArray(rules);
    } catch (error) {
      this.onError = true;
      this.error(error);
    }
    return this;
  }

  /**
   * @description Validar condicion
   * @param fiel
   * @param operator
   * @param value
   * @param isOr
   */
  static where (fiel: string, operator: string, value: any, isOr = false)  {
    try {
      if (this.onError) {
        return this;
      }
      const valid = _evalOperators(fiel, operator, value);
      this.operations.push(
        this.operations.length === 0 ?
        valid : isOr ? `||${valid}` : `&&${valid}`
      );
    } catch (error) {
      this.error(error);
    }
    return this;
  }

  /**
   * @description Validar regla
   * @param fiel
   * @param operator
   * @param value
   */
  static orWhere (fiel: string, operator: string, value: any)  {
    return this.where(fiel, operator, value, true);
  }

  /**
   * @description Retornar reglas
   */
  static get () {
    this.respond.validations = [];
    this.respond.properties = [];
    if (!this.onError && ((_evalOnlyBooleans(this.operations) === true || this.operations.length === 0))) {
      const validator = this.getValidator(this.validated);
      this.respond.validations = validator.rules;
      this.respond.properties = validator.properties;
    }
    return this.respond;
  }

  /**
   * @description Reset todas las variables
   */
  static reset() {
    this.validated = [];
    this.operations = [];
    this.respond = new RespondModel();
    this.respond.validations = [];
    this.respond.properties = [];
    this.onError = false;
    if (this._onSubscribe !== undefined) {
      this._onSubscribe.unsubscribe();
      this._onSubscribe = undefined;
    }

    // this.reactiveForm.clearValidators();
    // this.reactiveForm.updateValueAndValidity({emitEvent : false});
    // this.reactiveForm.enable();


    Object.keys(this.reactiveForm.controls).forEach((key) => {
      if (this.reactiveForm.get(key)) {
        this.reactiveForm.get(key).clearValidators();
        this.reactiveForm.get(key).updateValueAndValidity({emitEvent : false});
        this.reactiveForm.get(key).enable();
        this.reactiveForm.controls[key]['hide'] = false;
        this.reactiveForm.controls[key]['readOnly'] = false;
        this.reactiveForm.controls[key]['forced'] = false;
        this.toggleHide(key);
      }
    });

    if (this.defaultHidden && this.defaultHidden.length) {
      this.defaultHidden.forEach((controlName) => {
        if (this.reactiveForm.controls[controlName]) {
          this.reactiveForm.controls[controlName]['hide'] = true;
          this.toggleHide(controlName, true);
        }
      });
    }

    // this._onSubscribe = this.reactiveForm
    // .valueChanges
    // .debounceTime(this.debounceTime)
    // .subscribe((value) => {
    //   this.buildRules(this.rules, false);
    // });
    return this;
  }

  /**
   * @description Auto aplicar validations
   */
  static init (from: FormGroup, rules, defaultHidden: string[] = []) {
    this.reactiveForm = from;
    this.rules = rules;
    this.defaultHidden = defaultHidden;
    this.buildRules(rules, true);

    // if (this._onSubscribe === undefined) {
    //   this._onSubscribe = this.reactiveForm
    //     .valueChanges
    //     .debounceTime(this.debounceTime)
    //     .subscribe((value) => {
    //       this.buildRules(rules, false);
    //     });
    // }
    return this;
  }

  constructor () { }

}



// WEBPACK FOOTER //
// ./src/app/utils/trip2-query-builder/tr2-validation-builder.ts